import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const MagnifyingGlassSVG = styled(Icon).attrs({ viewBox: '0 0 38 40' })`
    width: 0.95em;
`;

function MagnifyingGlass({ color = navy, ...props }) {
    return (
        <MagnifyingGlassSVG
            data-test="icon-magnifying-glass"
            {...props}
        >
            <path
                d="M37.6,36L26.8,24.7c2.2-2.6,3.6-6,3.6-9.7c0-8.3-6.7-15-15-15s-15,6.7-15,15c0,8.3,6.7,15,15,15c2.5,0,4.8-0.6,6.8-1.7L33.4,40L37.6,36z M4.1,15c0-6.2,5.1-11.3,11.3-11.3S26.7,8.7,26.7,15s-5.1,11.3-11.3,11.3S4.1,21.2,4.1,15z"
                fill={color}
            />
        </MagnifyingGlassSVG>
    );
}

export {
    MagnifyingGlass as default,
    MagnifyingGlass,
};
